const ticketPath = /^\/tickets(?:\/[A-Z][A-Z0-9]{1,7}-[1-9][0-9]*)?\/?$/i;

function isTicketPath(pathname: string): boolean {
  return pathname.trim() === pathname && ticketPath.test(pathname);
}

export function createTicketLoginHref(pathname: string, search = ''): string {
  const destination = /^\/login\/?$/.test(pathname) ? readTicketLoginReturnTo(search) : pathname;
  return destination && isTicketPath(destination) ? `/?returnTo=${encodeURIComponent(destination)}` : '/';
}

export function readTicketLoginReturnTo(search: string): string | null {
  const pathname = new URLSearchParams(search).get('returnTo');
  return pathname && isTicketPath(pathname) ? pathname : null;
}
